<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('listeJournalEcriture.title') }}
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="ecritureSelect.length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-5 pdr-0 pdl-0">
            <b-input :placeholder="$t('listeJournalEcriture.actions.search')"
                     type="search" icon="magnify" v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">
                {{$t('listeJournalEcriture.actions.filter')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right">
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <div class="columns">
      <div class="column is-narrow">
        <div class="card card-content has-background-white">
          {{ $t('listeJournalEcriture.montantTotalPiece') }}
          <span class="has-text-weight-bold">{{ getTotalPieceOfPage
          + $t('general.discountType.money') }}</span>
        </div>
      </div>
    </div>
    <v-server-table url=""
      :columns="columns" :options="options" :ref="referenceTable"
      @loaded="finLoading" @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd"
      class='tableWithChildRow childrowEcheancierPaiement mgt-15px'>
      <template slot='afterTable'>
        <table-items-in-view @input="$refs[referenceTable].setLimit($event)"
                             :perPage="resultPerPage" />
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"/>
      </div>
      <div slot="dateComptable" slot-scope="props">
        {{ props.row.dateComptable | formatDate }}
      </div>
      <div slot="montant" slot-scope="props" class="is-pulled-right">
        {{props.row.montant | formatDevise}}
      </div>
      <div slot="isValid" slot-scope="props">
        <span v-if="props.row.isValid">
          {{$t('listeJournalEcriture.etat.valide')}}
        </span>
        <span v-else>
          {{$t('listeJournalEcriture.etat.nonValide')}}
        </span>
      </div>
      <div slot="typeEcriture" slot-scope="props">
        {{ $t(getLibelleEcriture(props.row)) }}
      </div>
      <div slot="reference" slot-scope="props">
        <router-link-blank
          v-if="getRoute(props.row)"
          :to="getRoute(props.row)"
          class="lien"
          :message="props.row.reference">
        </router-link-blank>
      </div>
      <div slot="actions" slot-scope="props">
        <verticalDotsDropdown
          :dropdownItems="dropdownItems(props.row.id)"
          :isButton="false"/>
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre">
      <filtre-journal-ecriture ref="filtreListeJournal"
                     @toggleFiltre="setShowFiltre"
                     @recherche="makeRechercheFilter"/>
    </div>
    <b-modal v-model="showModalAction" has-modal-card class="modal" width="400px">
      <createLotCompta :ecritures="this.ecritureSelect"
                       v-if="actionSelect === ACTION_CREATE_LOT"
                       @close="closeModal($event)"
                       @save="actionSelect = null"/>
      <associeLotCompta :ecritures="this.ecritureSelect"
                        v-if="actionSelect === ACTION_ASSOCIATE_LOT"
                        @close="closeModal($event)"
                        @save="actionSelect = null"/>
      <pop-up-prevention v-if="actionSelect === ACTION_GENERATION_ECRITURE"
        :messHeader="$t('listeJournalEcriture.generationEcriture.title')"
        messFooter=""
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @no="closeModal(false)"
        @yes="generationEcriture"
      />
    </b-modal>
    <b-modal v-model="showModalDelete" has-modal-card class="modal">
      <pop-up-prevention
        :mess-header="$t('listeJournalEcriture.popupSupprimer.title')"
        :is-error-popup="errorPopUp"
        :messagesPopup="messages"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.delete')"
        @yes="deleteEcriture(selectedId)"
        @no="showModalDelete = false">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import { JOURNAL_ECRITURE } from '@/configuration/compta/permissionsComptaConf';
import messageErreur from '@/services/general/messageErreur';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import filtreJournalEcriture from '@/components/compta/journalEcriture/filtreJournalEcriture';
import formatDate from '@/services/general/formatIsoDate';
import Ecriture from '@/components/commun/ecritureComptable/ecritureCompta';
import createLotCompta from '@/components/compta/journalEcriture/p_createLotCompta';
import associeLotCompta from '@/components/compta/journalEcriture/p_associeLotCompta';
import {
  TYPE_VENTE,
  TYPE_REGLEMENT,
  LISTE_TYPE,
  TYPE_ACHAT,
  TYPE_PAIEMENT,
  TYPE_OD,
} from '@/configuration/compta/ecritureConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { ACTIF, AUCUN } from '@/configuration/compta/lotConf';
import { SET_CRITERE } from '@/store/modules/compta/journalEcriture-mutation-type';
import { ACTION_CREATE_LOT, ACTION_ASSOCIATE_LOT, ACTION_GENERATION_ECRITURE } from '@/configuration/compta/journalConf';
import selecteurAction from '@/components/general/selecteurAction';
import TableItemsInView from '@/components/general/TableItemsInView';
import PopUpPrevention from '@/components/general/popUpPrevention';
import {
  generateByFacture,
  generateByRemiseBancaire,
  generateByOperationDiverse,
  deleteEcriture,
} from '@/api/compta/ifEcriture';
import messageSucces from '@/services/general/messageSucces';
import genererCritereRecherche from '@/services/compta/journal/genererCritereRechercheJournalEcriture';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_JOURNAL_EXERCICE } from '@/configuration/general/referenceTableConf';
import verticalDotsDropdown from '@/components/general/button/verticalDotsDropdown';
import validation from '@/services/compta/journal/validation';
import {
  MODULE_BAIL,
  MODULE_TLPE,
  MODULE_ACHAT,
} from '@/configuration/devisConf';

const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const journalEcriture = createNamespacedHelpers('journalEcriture');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      permsJournalEcriture: JOURNAL_ECRITURE,
      showFiltre: false,
      messages: [],
      errorPopUp: false,
      selectedId: null,
      showModalDelete: false,
      selectAllEcritureJournal: false,
      actions: [
        { action: ACTION_CREATE_LOT, translation: 'listeJournalEcriture.actions.createLot' },
        { action: ACTION_ASSOCIATE_LOT, translation: 'listeJournalEcriture.actions.associeLot' },
        { action: ACTION_GENERATION_ECRITURE, translation: 'listeJournalEcriture.actions.generationEcriture' },
      ],
      actionSelect: null,
      showModalAction: false,
      ACTION_CREATE_LOT: ACTION_CREATE_LOT,
      ACTION_ASSOCIATE_LOT: ACTION_ASSOCIATE_LOT,
      ACTION_GENERATION_ECRITURE: ACTION_GENERATION_ECRITURE,
      resultPerPage: 500,
      unsubscribeValue: null,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      referenceTable: REFERENCE_TABLE_JOURNAL_EXERCICE,
    };
  },
  computed: {
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeJournalEcriture.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeJournalEcriture.title'), route: '', isActive: true },
      ];
      return output;
    },
    ...journalEcriture.mapGetters({
      items: 'items',
      totalCount: 'totalCount',
      critereRecherche: 'criteresRecherche',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateComptable: this.$t('listeJournalEcriture.tab.date'),
          reference: this.$t('listeJournalEcriture.tab.referencePiece'),
          libelle: this.$t('listeJournalEcriture.tab.libelle'),
          journal: this.$t('listeJournalEcriture.tab.journal'),
          'ifLot.libelle': this.$t('listeJournalEcriture.tab.lot'),
          'ifLot.etat': this.$t('listeJournalEcriture.tab.etatLot'),
          montant: this.$t('listeJournalEcriture.tab.montant'),
          isValid: this.$t('listeJournalEcriture.tab.isValid'),
          typeEcriture: this.$t('listeJournalEcriture.tab.typeEcriture'),
          actions: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
          visu: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        childRow: Ecriture,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          data.query.societeId = this.societeActiveId;
          data.query.dateComptable.dateDebut = formatDate(data.query.dateComptable.dateDebut);
          data.query.dateComptable.dateFin = formatDate(data.query.dateComptable.dateFin);
          return this.actionsLoadJournalEcriture(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          actions: 'colonneSelected',
          selected: 'colonneSelected',
          visu: 'colonneSelected',
        },
        sortable: ['dateComptable', 'libelle', 'journal', 'ifLot.libelle', 'ifLot.etat', 'isValid', 'reference', 'typeEcriture'],
      };
    },
    columns() {
      return ['selected', 'dateComptable', 'libelle', 'typeEcriture', 'reference', 'journal', 'montant', 'ifLot.libelle', 'ifLot.etat', 'isValid', 'actions'];
    },
    nombreCritere() {
      let nombreCritere = 0;
      nombreCritere += this.critereRecherche.isValid !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.etatLot.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.types.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.exercice.dateDebut ? 1 : 0;
      nombreCritere += this.critereRecherche.referencePiece.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.dateComptable.dateDebut
      || this.critereRecherche.dateComptable.dateFin ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    iconSelectTotal() {
      if (this.selectAllEcritureJournal) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    ecritureSelect() {
      return this.items.filter(item => item.selected).map(el => el.id);
    },
    getTotalPieceOfPage() {
      if (this.items.length === 0) return 0;
      return Number(this.items.map((item) => item.totalTtcPiece).reduce((acc, current) => {
        return acc + current;
      }).toFixed(2)).toLocaleString();
    },
  },
  components: {
    verticalDotsDropdown,
    PopUpPrevention,
    AppBreadcrumb: breadcrumb,
    filtreJournalEcriture,
    createLotCompta,
    associeLotCompta,
    routerLinkBlank,
    selecteurAction,
    TableItemsInView,
    parametrageTable,
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  methods: {
    ...journalEcriture.mapActions({
      actionsLoadJournalEcriture: 'loadJournalEcriture',
    }),
    ...journalEcriture.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async reinitialiserFiltre() {
      await this.$refs.filtreListeJournal.initializeFiltre();
      this.$refs.filtreListeJournal.viderCritere();
      this.$refs.filtreListeJournal.appliquerCritere();
      this.showFiltre = false;
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeJournal.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    handleAction(action) {
      this.actionSelect = action;
      if (action === ACTION_GENERATION_ECRITURE) {
        if (this.items.filter((el) => { return el.selected && el.ifLotId; }).length > 0) {
          this.showModalAction = true;
        } else {
          this.generationEcriture();
        }
        return;
      }
      this.showModalAction = true;
    },
    async generationEcriture() {
      try {
        this.debutLoading();
        this.showModalAction = false;
        const promises = [];
        [...new Set(this.items.filter((el) => { return el.selected === true; })
          .map(el => el.referencePiece))]
          .map(id => {
            return this.items.find(el => el.selected === true && el.referencePiece === id);
          })
          .forEach((el) => {
            switch (el.typeEcriture) {
              case TYPE_REGLEMENT:
              case TYPE_PAIEMENT:
                promises.push(generateByRemiseBancaire(
                  { referencePieceId: el.referencePiece, typeEcriture: el.typeEcriture },
                ));
                break;
              case TYPE_VENTE:
              case TYPE_ACHAT:
                promises.push(generateByFacture(el.referencePiece, el.typeEcriture));
                break;
              case TYPE_OD:
                promises.push(generateByOperationDiverse(
                  { referencePieceId: el.referencePiece, typeEcriture: el.typeEcriture },
                ));
                break;
              default:
                break;
            }
          });
        await Promise.all(promises);
        this.recherche();
        this.finLoading();
        this.selectAllEcritureJournal = false;
        messageSucces(this.$i18n.t('listeJournalEcriture.generationEcriture.success'));
      } catch (e) {
        this.finLoading();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    createCritereRechercheBase() {
      if (this.$route.params.ids && this.$route.params.ids.length > 0) {
        const criteres = genererCritereRecherche();
        criteres.referencePiece = this.$route.params.ids;
        this.setCritereRecherche(criteres);
        return;
      }
      this.critereRecherche.referencePiece = [];
      const criteres = cloneDeep(this.critereRecherche);
      const dateJour = new Date();
      if (this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.nbreMoisDefaultFiltreJournal.key,
      )) dateJour.setMonth(dateJour.getMonth() - 1);
      criteres.dateComptable.dateDebut = new Date(dateJour.getFullYear(), dateJour.getMonth(), 1);
      criteres.dateComptable.dateFin = new Date(dateJour.getFullYear(), dateJour.getMonth() + 1, 0);
      criteres.etatLot = [ACTIF, AUCUN];
      this.setCritereRecherche(criteres);
    },
    getLibelleEcriture(journal) {
      const type = LISTE_TYPE.find((type) => {
        return type.code === journal.typeEcriture;
      });
      return type ? type.libelle : '';
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    selectAll() {
      this.selectAllEcritureJournal = !this.selectAllEcritureJournal;
      this.items.forEach(item => {
        item.selected = this.selectAllEcritureJournal;
      });
    },
    dropdownItems(id) {
      return [
        {
          action: () => {
            this.showModalDelete = true;
            this.selectedId = id;
            this.errorPopUp = false;
            this.messages = [];
          },
          libelle: this.$t('pageCompta.journalEcriture.actions.supprimer'),
          id: 0,
        },
      ];
    },
    async deleteEcriture(id) {
      this.errorPopUp = false;
      this.messages = [];
      try {
        await deleteEcriture(id);
        this.showModalDelete = false;
        this.recherche();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validation(e.response, this.messages);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        throw e;
      }
    },
    closeModal(doitRecharger) {
      this.showModalAction = false;
      if (doitRecharger) this.recherche();
    },
    getRoute(journal) {
      const params = { id: journal.referencePiece };
      let name = '';
      switch (journal.typeEcriture) {
        case TYPE_VENTE:
          name = 'c.bodac.factures'; break;
        case TYPE_REGLEMENT:
          name = 'c.bodac.remises_bancaires'; break;
        case TYPE_ACHAT:
          switch (journal.module) {
            case MODULE_BAIL:
              name = 'c.baux.facture_achat'; break;
            case MODULE_TLPE:
              name = 'c.gabed.titre_recette'; break;
            case MODULE_ACHAT:
              name = 'c.achat.factures'; break;
            default:
              name = 'c.baux.facture_achat'; break;
          }
          break;
        case TYPE_PAIEMENT:
          switch (journal.module) {
            case MODULE_BAIL:
              name = 'c.baux.lot_paiement'; break;
            case MODULE_TLPE:
              name = 'c.gabed.lot_paiement_recette'; break;
            case MODULE_ACHAT:
              name = 'c.achat.lot_paiements_factures'; break;
            default:
              name = 'c.baux.lot_paiement'; break;
          }
          break;
        case TYPE_OD:
          name = 'c.comptabilite.operation_diverse'; break;
        default:
          name = 'c.bodac.factures'; break;
      }
      return ({ name: name, params: params });
    },
  },
  async created() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.nbreMoisDefaultFiltreJournal.key]);
      this.createCritereRechercheBase();
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.mountedLoadingEnd = true;
      this.setInformationPage(this.$t('pageCompta.journalEcriture.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
